<template>
  <div class="contact py-0">
    <div class="bg" :style="{ backgroundImage: 'url(' + external5 + ')' }"></div>
    <v-container fluid class="mt-12 pa-9 pa-md-16" fill-height>
      <v-row align="center" justify="center" class="flex-row-reverse flex-md-row flex-column-reverse">
        <v-col class=" px-6">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.406141817596!2d11.103918599999998!3d43.847409999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a589bf68f87eb%3A0x5ec6df0e2e7678dc!2sStylem%20Italia%20S.R.L.!5e0!3m2!1sen!2sit!4v1745409239883!5m2!1sen!2sit" width="100%" height="350" style="border: 0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </v-col>
        <v-col cols="12" md="6" class="uppercase px-6" >
          <h3 class="uppercase bold mb-3 company">STYLEM ITALIA S.R.L</h3>
          <div class="address">
            <h6>via delle Fonti, 424</h6>
            <h6>59100 Prato</h6>
            <h6>Italia</h6>
          </div>
          <div class="my-8 contact">
            <h6>Tel: <span class="bold">+39 0574 870718</span></h6>
            <h6>Fax: <span class="bold">+39 0574 870720</span></h6>
            <h6>Mail: <a class="bold" href="mailto:contactus@stylemitalia.it">contactus@stylemitalia.it</a></h6>
            <h6>PEC: <a class="bold" href="mailto:stylemitalia@legalmail.it">stylemitalia@legalmail.it</a></h6>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import external5 from '@/assets/img/external5.jpg'
export default {
  data () {
    return {
      external5
    }
  }
}
</script>

<style lang="scss" scoped>
.company {
  letter-spacing: 1px;
}

.contact {
  height: 100%;
}

.bg {
  background-size: cover;
  background-position: center center;
  min-height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 0;
  opacity: 0.2;
}

.container {
  position: relative;
}
</style>
